module.exports = __webpack_public_path__ + "static/ngconf19-d28a7f578b01fbe4b5177cd70240fd47.jpg";